import React from 'react';

// material-ui
import { Typography } from '@mui/material';
import { userRoles } from '../../utils/constants';

// ==============================|| Circular Loader ||============================== //

const MemberChip = ({ role }) => {
    return (
        <div
            style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                height: '80%',
                width: '60%',
                backgroundColor:
                    role === userRoles.RESIDENT || role === userRoles.TENANT
                        ? 'rgba(45, 143, 87, .1)'
                        : 'rgba(255, 192, 0, .1)',
                borderRadius: '5px'
            }}
        >
            <Typography
                sx={{
                    fontSize: '13px',
                    marginX: '10px'
                }}
                component="span"
                variant="body1"
                textTransform={'capitalize'}
                color={
                    role === userRoles.RESIDENT || role === userRoles.TENANT
                        ? 'rgba(45, 143, 87, 1)'
                        : 'rgba(255, 192, 0, 1)'
                }
            >
                {`${role === 'guest' ? role : role === 'tenant' ? role : 'occupant'}`}{' '}
            </Typography>
        </div>
    );
};

export default MemberChip;
